import { useTranslation } from 'react-i18next';
import { ReadMore, ViewDetailsFor } from 'autogen/translation-keys/trans-website-shared-buttons';
import { Button, ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { eventCategoryToContext } from 'modules/tracking/GA4';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import type { TrackingCategory } from 'modules/tracking/UAEventTracking';
import type { ProductActionProps } from '../../shared/types';

function track(eventCategory: TrackingCategory) {
    const context = eventCategoryToContext(eventCategory);

    if (context) {
        GA4Tracking({
            eventName: 'read_more',
            context,
            category: 'ecommerce',
            eventParams: [{ param_name: 'read_more_type', param_value: 'description' }]
        });
    }
}

export function ReadMoreButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['MedicalReadMore']) {
    const { t } = useTranslation();
    const { eventCategory } = trackingInfo;

    // TODO nkr NavigationLink Update later
    return (
        <Button as="a" href={params.productNavigationLink.url} {...restProps} onClick={() => track(eventCategory)}>
            {children || t(ReadMore)}
        </Button>
    );
}

export function ReadMoreButtonCompact({ params, trackingInfo, ...restProps }: ProductActionProps['ReadMore']) {
    const { eventCategory } = trackingInfo;
    const { t } = useTranslation();

    const getProductName = () => {
        if (!params.customerNotification?.productName?.lines) return params.listName;

        return params.customerNotification.productName.lines.map((line) => line.value).join(': ');
    };

    // TODO nkr NavigationLink
    return (
        <ButtonWithIcon
            as="a"
            href={params.productNavigationLink.url}
            icon={<Icon type="ChevronRight" size={16} fill="white" />}
            aria-label={`${t(ViewDetailsFor)} ${getProductName()}`}
            {...restProps}
            onClick={() => track(eventCategory)}
        />
    );
}

export default Object.assign(ReadMoreButton, {
    Compact: ReadMoreButtonCompact
});
